// Helpers for mobile-safe numeric inputs.
// We use text inputs with inputMode instead of type="number" because browsers
// allow scientific notation characters such as e/E/+/- in number fields.

export function cleanDecimalInput(value, decimals = 2, integerDigits = 12) {
  if (value === null || value === undefined) return "";
  let raw = String(value);
  // Reject pasted scientific/negative/formula-like numeric payloads instead of silently changing them.
  if (/[-−+]/.test(raw) || /[a-z]/i.test(raw)) return "";
  // FinVault uses dot for decimals. Commas are treated as thousand separators.
  raw = raw.replace(/,/g, "");
  let text = raw.replace(/[^0-9.]/g, "");
  const firstDot = text.indexOf(".");
  if (firstDot !== -1) {
    text = text.slice(0, firstDot + 1) + text.slice(firstDot + 1).replace(/\./g, "");
  }
  let [whole = "", fraction = ""] = text.split(".");
  whole = whole.slice(0, integerDigits);
  if (decimals === 0) return whole;
  if (text.includes(".")) return `${whole}.${fraction.slice(0, decimals)}`;
  return whole;
}

export function cleanMoneyInput(value) {
  return cleanDecimalInput(value, 2, 12);
}

export function cleanSignedMoneyInput(value) {
  if (value === null || value === undefined) return "";
  const raw = String(value).trim();
  const negative = raw.startsWith("-") || raw.startsWith("−");
  if (/[+]/.test(raw) || /[a-z]/i.test(raw)) return "";
  const unsigned = raw.replace(/^[-−]/, "");
  const cleaned = cleanDecimalInput(unsigned, 2, 12);
  return negative && cleaned ? `-${cleaned}` : cleaned;
}

export function cleanGramInput(value) {
  return cleanDecimalInput(value, 4, 9);
}

export function cleanPercentInput(value) {
  const cleaned = cleanDecimalInput(value, 2, 3);
  const num = Number(cleaned);
  if (Number.isFinite(num) && num > 100) return "100";
  return cleaned;
}

export function cleanIntegerInput(value, digits = 4) {
  if (value === null || value === undefined) return "";
  return String(value).replace(/\D/g, "").slice(0, digits);
}

export function blockInvalidNumberKeys(event) {
  if (["e", "E", "+", "-"].includes(event.key)) event.preventDefault();
}
